import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import store from 'src/services/redux/app/Store';
import { ITicket } from '../../../interfaces/ticket/ticket.interface';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;
enum Status {
  loading = 'loading',
  done = 'done',
  fail = 'fail',
}

interface IState {
  status: Status | '';
  data: ITicket | any;
  error: any;
}


const initialState: IState = {
  status: '',
  data: null,
  error: null,
};

export const checkNewTickets = createAsyncThunk('check-new-tickets', async () => {
  const vendorId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get<ITicket>(`${VENDOR_MC_URL}/${vendorId}/check-new-tickets`);
  return res.data;
});


const ticketSlice = createSlice({
  name: 'ticket-list',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(checkNewTickets.pending, (state) => {
      state.status = Status.loading;
    });
    builder.addCase(checkNewTickets.fulfilled, (state, action) => {
      state.status = Status.done;
      state.data = action.payload;
    });
    builder.addCase(checkNewTickets.rejected, (state) => {
      state.error = 'Mesajlar Listelenmedi!';
      state.status = Status.fail;
    });
  },
});

export default ticketSlice.reducer;
